// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLogin24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.75 3H18C19.1046 3 20 3.89543 20 5V19C20 20.1046 19.1046 21 18 21L10.8013 20.9983L10.75 21C10.3358 21 10 20.6642 10 20.25L10.0068 20.1482C10.0565 19.7822 10.3703 19.5 10.75 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V5C18.5 4.72386 18.2761 4.5 18 4.5L10.8013 4.49827L10.75 4.5C10.3358 4.5 10 4.16421 10 3.75L10.0068 3.64823C10.0565 3.28215 10.3703 3 10.75 3ZM13.7803 11.2197L9.78033 7.21967C9.48744 6.92678 9.01256 6.92678 8.71967 7.21967L8.64705 7.30379C8.4292 7.5974 8.4534 8.01406 8.71967 8.28033L11.439 11H3.75C3.33579 11 3 11.3358 3 11.75L3.00685 11.8518C3.05651 12.2178 3.3703 12.5 3.75 12.5H11.438L8.71967 15.2197C8.42678 15.5126 8.42678 15.9874 8.71967 16.2803C9.01256 16.5732 9.48744 16.5732 9.78033 16.2803L13.7803 12.2803C14.0732 11.9874 14.0732 11.5126 13.7803 11.2197Z"
				/>
			</Svg>
		);
	}
);
SvgLogin24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLogin24;
